// ** Type Imports
import { OwnerStateThemeType } from './'

const Autocomplete = () => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: ({ theme }: OwnerStateThemeType) => ({
          boxShadow: theme.shadows[6]
        }),
        root: {
          // Unshrunk outlined labels sit in the field like a placeholder; keep them clear of
          // the popup / clear icons so text does not run under the dropdown triangle.
          '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
            maxWidth: 'calc(100% - 48px)'
          }
        }
      }
    }
  }
}

export default Autocomplete
